import styled, { css } from 'styled-components';

import { ValuePosition } from '@/components/progressBars/LinearProgressBar';

export enum ProgressBarMode {
  PRIMARY_WHITE = 0,
  PRIMARY_GRAY = 1,
  SECONDARY = 2,
  ERROR = 3,
  SUCCESS = 4,
  GREEN = 5,
  GREEN_WHITE = 6,
}

export interface ScProgressBarProps {
  value: number;
  valuePx?: number;
  mode: ProgressBarMode;
  valuePosition?: ValuePosition;
  height?: number;
  padding?: number;
  borderRadius?: string;
  borderRadiusInner?: string;
}

export const ScProgressBar = styled.div<ScProgressBarProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  .progress-bar-line {
    display: flex;
    position: relative;
    width: 100%;
    padding: ${({ padding }) => `${padding ?? 2}px`};
    height: ${({ height }) => `${height || 12}px`};
    border-radius: ${({ borderRadius }) => borderRadius || '8px'};
    background-color: ${({ theme, mode }) => {
      switch (mode) {
        case ProgressBarMode.PRIMARY_GRAY:
          return theme.gray1Color;
        case ProgressBarMode.PRIMARY_WHITE:
        case ProgressBarMode.GREEN_WHITE:
          return theme.whiteColor;
        case ProgressBarMode.ERROR:
        case ProgressBarMode.SUCCESS:
          return theme.gray1Color;
        default:
          return theme.blackColor;
      }
    }};
    & > .completed {
      height: 100%;
      width: ${({ value, valuePx }) =>
        valuePx ? `${valuePx}px` : `${value}%`};
      background: ${({ mode, theme }) => {
        switch (mode) {
          case ProgressBarMode.SECONDARY:
            return theme.secondaryColor;
          case ProgressBarMode.GREEN:
          case ProgressBarMode.GREEN_WHITE:
            return theme.freshLimeGradint;
          case ProgressBarMode.ERROR:
            return theme.error;
          case ProgressBarMode.SUCCESS:
            return theme.success;
          default:
            return theme.solarFlareGradient;
        }
      }};
      transition: width 0.5s ease-in-out;
      border-radius: ${({ borderRadiusInner }) => borderRadiusInner || '8px'};
    }

    & > .dot {
      position: absolute;
      left: ${({ value }) => `calc(${value}%)`};
      box-sizing: border-box;
      width: 14px;
      height: 14px;
      background: ${({ theme }) => theme.whiteColor};
      border: ${({ theme }) => `2px solid ${theme.yellow1Color}`};
      border-radius: 8px;
      transform: translate(-50%, -20%);
    }

    & > .progress-value {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: ${({ theme }) => theme.blackColor};
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0.16px;
      text-align: center;
    }
  }

  .current-progress {
    white-space: nowrap;

    ${({ valuePosition, value, theme }) =>
      valuePosition === ValuePosition.TOP
        ? css`
            font-weight: 700;
            font-size: 8px;
            line-height: 1.5;
            position: absolute;
            left: ${value}%;
            transform: translate(-50%, -120%);
            text-align: center;
            letter-spacing: 0.02em;
            color: ${theme.whiteColor};
          `
        : css`
            font-size: 14px;
            line-height: 20px;
            color: ${({ theme }) => theme.blackLightColor};
          `}
  }
`;
